
import { Component, VModel, Watch } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import ObservationMixin from '@/_mixins/observation'
import { observationIcons } from '@/types/observation'

@Component({
    mixins: [ObservationMixin],
})
export default class SortingComponent extends Mixins<MixinInterface>(ObservationMixin) {
    @VModel() sorting!: Record<string, string | null>

    allSorting = [
        'projectObservationId',
        'status',
        'priority',
        'severity',
        'cost',
        'dueStatus',
        'ageOrClosingTime',
        'happenedAt',
        'createdAt',
        'updatedAt',
        'category',
        'cause',
        'location',
    ]

    get observationIcons() {
        return observationIcons
    }

    localSorting = {}

    @Watch('sorting', { immediate: true, deep: true })
    handlerLocalSorting() {
        this.localSorting = this.lodash.cloneDeep(this.sorting)
    }

    setSortValue(key: string, val: string | null) {
        this.localSorting[key] = val
        this.sorting = this.lodash.cloneDeep(this.localSorting)
    }

    get sortCount() {
        return Object.keys(this.localSorting).filter((key) => this.localSorting[key] != null).length
    }

    get singleSort() {
        return this.sortCount == 1
            ? Object.keys(this.localSorting).find((key) => this.localSorting[key] != null)
            : null
    }

    // Labels
    sortingLabel(key: any) {
        const translationKey = `observation_labels['observation.${key}']`
        return this.$te(translationKey)
            ? this.$t(translationKey)
            : this.$t(`observation_fe['filter.${key}.label']`)
    }

    sortingValue(key: string, val: string) {
        if (!val) return ''
        const translationKey = `observation_labels['bservations.filters.${key}.${val}']`
        return this.$te(translationKey)
            ? this.$t(translationKey)
            : this.$t(
                  `observation_fe['filter.common.${
                      val.includes('-') ? 'descending' : 'ascending'
                  }']`
              )
    }

    sortingsItems(key: string) {
        return [
            {
                value: key,
                text: this.sortingValue(key, key),
            },
            {
                value: `-${key}`,
                text: this.sortingValue(key, `-${key}`),
            },
        ]
    }

    cleanAllSorting() {
        Object.keys(this.localSorting).map((key) => (this.localSorting[key] = null))

        this.sorting = this.lodash.cloneDeep(this.localSorting)
    }
}
